import NoApplicationPlaceholder from './noApplicationPlaceholder';
import PageBackground from 'components/v2/PageBackground';

interface NoApplicationScreenProps {
    maxWidth?: 'sm' | 'md' | 'lg' | 'xl';
}

const fillRootSx = {
    minHeight: 0,
    height: '100%',
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
} as const;

const fillContentSx = {
    p: { xs: 2, sm: 3 },
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
} as const;

const NoApplicationScreen = ({ maxWidth }: NoApplicationScreenProps) => (
    <PageBackground maxWidth={maxWidth} rootSx={fillRootSx} sx={fillContentSx}>
        <NoApplicationPlaceholder />
    </PageBackground>
);

export default NoApplicationScreen;
